export default (fillBookingDataRQ, serviceType) => {
    if (serviceType === 'CARRENT') {
        const {
            tourists: [tourLead],
            ...rq
        } = fillBookingDataRQ
        const {phone, ...driver} = tourLead
        driver.phoneNumber = phone
        return {driver, ...rq}
    }
    return fillBookingDataRQ
}
